import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import GoalFlag from '../../../assets/GoalFlag.png';
import { ROLES } from '../../../constants';
import { RecipientDropdown } from '../../../components/recipientDropdown/RecipientDropdown';

interface GoalHeaderProps {
    inputMonth: number;
    inputYear: number;
    isNewGoal: boolean;
    hideNewGoalBtnPayoutTextbox: boolean;
    setNewGoal: (value: boolean) => void;
    onDateChange: (month: number, year: number) => void;
    recipientList: any[];
    selectedRecipientEmployee: any;
    setSelectedRecipientEmployee: React.Dispatch<any>;
    viewState?: string;
}

export const GoalHeader = (props: GoalHeaderProps) => {
    const [goalDate, setGoalDate] = useState<Date | string>('');
    const [isNewGoal, setIsNewGoal] = useState<boolean>(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const handleRecipientChange = (e: any) => {
        const selectedRecipient = props?.recipientList?.filter(
            (item: any) => item.employeeNumber === e.value
        );
        props?.setSelectedRecipientEmployee(selectedRecipient?.length > 0 ? selectedRecipient[0] : null);
    };

    useEffect(() => {
        setGoalDate(new Date(props.inputYear, props.inputMonth - 1, 1));
    }, [props.inputMonth, props.inputYear]);

    useEffect(() => {
        setIsNewGoal(props.isNewGoal);
    }, [props.isNewGoal]);
    return (
        <>
            <div className="goal-summary-header">
                <div className="employee-header width-16 m-b-20">
                    <img src={GoalFlag} alt="revgen" />
                    <span>RevGen Sales Goals</span>
                </div>
                {!isNewGoal && !props.hideNewGoalBtnPayoutTextbox && (props?.viewState !== 'read-only') && !ROLES.Agents.includes(userManagerLevel) && (
                    <Button
                        label="New Goal"
                        icon="btnPlusIcon"
                        className="btn-primary"
                        onClick={() => {
                            setIsNewGoal(true);
                            props.setNewGoal(true);
                        }}
                    />
                )}
            </div>
            <div className="row mt-2">
                <div className="col-md-3">
                    <div className="content">
                    <label htmlFor="goal-date">Month</label>
                        <Calendar
                            id="goal-date"
                            value={goalDate}
                            view="month"
                            dateFormat="M-yy"
                            onChange={(e: any) => {
                                setGoalDate(e.value);
                                const month = e.value.getMonth() + 1;
                                const year = e.value.getFullYear();
                                props.onDateChange(month, year);
                            }}
                            showIcon
                            className="custom-calendar mb-2"
                        />
                    </div>
                </div>
                <div className="col-md-4" data-testid="abc">
                    <RecipientDropdown
                        recipientList={props?.recipientList}
                        selectedRecipient={props?.selectedRecipientEmployee}
                        handleRecipientChange={handleRecipientChange}
                    />
                </div>
            </div>
        </>
    );
};
